import { render, staticRenderFns } from "./abroadDetail.vue?vue&type=template&id=ef3285ba&scoped=true"
import script from "./abroadDetail.vue?vue&type=script&lang=js"
export * from "./abroadDetail.vue?vue&type=script&lang=js"
import style0 from "./abroadDetail.vue?vue&type=style&index=0&id=ef3285ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3285ba",
  null
  
)

export default component.exports